import { createAction } from 'shared/utils';

export const AMENITIES_ORDER = {
  GETS: createAction('AMENITIES_ORDER_GETS'),
  EXPORT: createAction('AMENITIES_ORDER_EXPORT'),
};
